/**
 * Provenance of a ProvisionContractAgent row — and of an amount overwrite on it (04-frontend.md
 * §2.6, E6/A6-11). Binding for the engine: a row or overwrite marked MANUAL is never touched by a
 * recalculation, while AUTOMATIC is rebuilt on every reconcile.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionContractAgentSource}.
 * The backend persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order
 * below MUST match the backend exactly and new constants MUST only be appended at the end — never
 * inserted between existing ones, which would silently re-map every stored value
 * (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionContractAgentSource {

    AUTOMATIC,
    MANUAL
}
